import { render, staticRenderFns } from "./E-mail.vue?vue&type=template&id=79ce2f96"
import script from "./E-mail.vue?vue&type=script&lang=js"
export * from "./E-mail.vue?vue&type=script&lang=js"
import style0 from "./E-mail.vue?vue&type=style&index=0&id=79ce2f96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports